module.exports = __webpack_public_path__ + "static/img/1.527f54b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/1.jpg
// module id = jmyQ
// module chunks = 0